import React from "react";
import {Link} from "react-router-dom";
import indoorp1_5 from "../../Assets/products/indoor-p15.jpg";
import indoorp1_8 from "../../Assets/products/indoor-p18.png";
import indoorp2 from "../../Assets/Copy of LED Video Wall Indoor P-4.png";
import indoorp2_5 from "../../Assets/LED Video Wall Indoor P-2.jpg";
import indoorp4 from "../../Assets/LED Video Wall Outdoor P-2.5.jpg";

import indoorImg from "../../Assets/indoor-led.jpg";
import adImg from "../../Assets/Copy of LED Video Wall Indoor P-4.png";
import controlImg from "../../Assets/control.jpeg";
import retailImg from "../../Assets/LED Video Wall Outdoor P-2.5.jpg";

import { motion } from "framer-motion";
import { Sparkles, Monitor, Puzzle, Users, Maximize2, Wrench } from "lucide-react";

const features = [
  { title: "Ultra HD Resolution", icon: <Sparkles size={36} /> },
  { title: "High Refresh Rate", icon: <Monitor size={36} /> },
  { title: "Seamless Panel Integration", icon: <Puzzle size={36} /> },
  { title: "Wide Viewing Angles", icon: <Users size={36} /> },
  { title: "Customizable Sizes", icon: <Maximize2 size={36} /> },
  { title: "Easy Maintenance & Installation", icon: <Wrench size={36} /> },
];

const IndoorDisplay = () => {
  return (
    <>
      {/* ================= HERO SECTION ================= */}
      <section className="bg-[#F4F2F3] min-h-screen flex items-center px-6 lg:px-16 py-20">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 items-center">

          <div>
            <h1 className="text-4xl lg:text-6xl font-bold leading-tight mb-8">
              <span className="text-blue-600"> Beneicon</span> Indoor LED <br />
              
              <span className="text-blue-700">Video Display</span>
            </h1>

            <p className="text-gray-600 text-lg max-w-xl mb-10 leading-relaxed">
              Premium indoor LED display solutions designed for conference rooms,
              auditoriums, retail stores, classrooms, and corporate environments.
              Delivering vibrant visuals with seamless clarity and performance.
            </p>

                      <a
  href="https://wa.me/+917065993135"
  target="_blank"
  rel="noopener noreferrer"
  className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-purple-700 transition shadow-lg inline-block"
>
  Request Your Demo
</a>
          </div>

          <div className="flex justify-center">
            <img
              src={indoorImg}
              alt="Indoor LED Display"
              className="w-full max-w-xl rounded-2xl shadow-2xl"
            />
          </div>

        </div>
      </section>

      {/* ================= FEATURES SECTION ================= */}
      <section className="bg-[#F4F2F3] py-20 px-6">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 lg:grid-cols-3 gap-10">

          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className="bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-500 p-12 flex flex-col items-center text-center"
            >
              <div className="mb-6 text-black">
                {feature.icon}
              </div>

              <h3 className="text-lg font-semibold text-gray-800">
                {feature.title}
              </h3>
            </motion.div>
          ))}

        </div>
      </section>
     <section className="bg-[#F4F2F3] py-20 px-6">
  <div className="max-w-7xl mx-auto">

    <h2 className="text-3xl font-bold mb-12">
      Related Products
    </h2>

    <div className="grid md:grid-cols-3 gap-10">

      <Link to="/indoor-p15" className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition overflow-hidden">
        <img
          src={indoorp1_5}
          alt="Indoor LED P-1.5"
          className="h-64 w-full object-contain group-hover:scale-105 transition duration-500"
        />
        <div className="p-6 text-center font-semibold">
          Indoor LED Video Display P-1.5
        </div>
      </Link>

      <Link to="/indoor-p18" className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition overflow-hidden">
        <img
          src={indoorp1_8}
          alt="Indoor LED P-1.8"
          className="h-64 w-full object-contain group-hover:scale-105 transition duration-500"
        />
        <div className="p-6 text-center font-semibold">
          Indoor LED Video Display P-1.8
        </div>
      </Link>

      <Link to="/indoor-p25" className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition overflow-hidden">
        <img
          src={indoorp2_5}  
          alt="Indoor LED P-2.5"
          className="h-64 w-full object-contain group-hover:scale-105 transition duration-500"
        />
        <div className="p-6 text-center font-semibold">
          Indoor LED Video Display P-2.5
        </div>
      </Link>

      <Link to="/indoor-p2" className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition overflow-hidden">
        <img
          src={indoorp2}
          alt="Indoor LED P-2"
          className="h-64 w-full object-contain group-hover:scale-105 transition duration-500"
        />
        <div className="p-6 text-center font-semibold">
          Indoor LED Video Display P-2
        </div>
      </Link>

      <Link to="/indoor-p4" className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition overflow-hidden">
        <img
          src={indoorp4}
          alt="Indoor LED P-4"
          className="h-64 w-full object-contain group-hover:scale-105 transition duration-500"
        />
        <div className="p-6 text-center font-semibold">
          Indoor LED Video Display P-4
        </div>
      </Link>

    </div>
  </div>
</section>
{/* ================= APPLICATIONS SECTION ================= */}
      <section className="bg-[#F4F2F3] py-24 px-6">
        <div className="max-w-7xl mx-auto">

          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-blue-700 mb-4">
              Applications
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Indoor LED displays enhance communication and engagement across professional environments.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-10">

            {/* Conference & Corporate */}
            <div className="group rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500">
              <div className="overflow-hidden">
                <img
                  src={adImg}
                  alt="Conference & Corporate"
                  className="w-full h-64 object-contain group-hover:scale-110 transition duration-700"
                />
              </div>
              <div className="p-6 text-center">
                <h3 className="text-xl font-semibold text-gray-800 mb-3">
                  Conference & Corporate
                </h3>
                <p className="text-gray-600 text-sm">
                  Enhance presentations and collaboration in boardrooms, conference halls, and offices.
                </p>
              </div>
            </div>

            {/* Control Room */}
            <div className="group rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 bg-white">
              <div className="overflow-hidden">
                <img
                  src={controlImg}
                  alt="Control Room"
                  className="w-full h-64 object-contain group-hover:scale-110 transition duration-700"
                />
              </div>
              <div className="p-6 text-center">
                <h3 className="text-xl font-semibold text-gray-800 mb-3">
                  Command & Control Rooms
                </h3>
                <p className="text-gray-600 text-sm">
                  Reliable real-time monitoring displays for operational excellence and security management.
                </p>
              </div>
            </div>

            {/* Retail */}
            <div className="group rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500">
              <div className="overflow-hidden">
                <img
                  src={retailImg}
                  alt="Retail"
                  className="w-full h-64 object-contain group-hover:scale-110 transition duration-700"
                />
              </div>
              <div className="p-6 text-center">
                <h3 className="text-xl font-semibold text-gray-800 mb-3">
                  Retail & Showrooms
                </h3>
                <p className="text-gray-600 text-sm">
                  Engage customers with dynamic in-store promotions and immersive visual experiences.
                </p>
              </div>
            </div>

          </div>

        </div>


                      {/* FOOTER TAGLINE */}
        <div className="mt-20 text-center">
          <p className="text-lg font-semibold text-gray-800">
            <span className="text-blue-600 font-semibold">Beneicon</span> — Trust. Technology. Impact.
          </p>
        </div>
      </section>


    </>
  );
};

export default IndoorDisplay;
